import React, { useCallback } from 'react'
import { Form } from 'antd'
import cs from 'classnames'

import type { FormItemProps } from 'antd/lib/form'

import styles from './index.module.less'

export interface IFormItemProps extends FormItemProps {
  desc?: React.ReactNode
  gap?: number
}

// 自定义FormItem
const FormItem: React.FC<IFormItemProps> = ({ label, desc, gap, className, ...rest }) => {
  const getDesc = useCallback((desc) => {
    const Desc = ({ content }) => (content ? <span className={styles.desc}>{content}</span> : null)

    if (!desc) {
      return null
    } else {
      return Array.isArray(desc) ? desc.map((val) => <Desc content={val} />) : <Desc content={desc} />
    }
  }, [])

  return (
    <Form.Item
      className={cs(className, styles.formItem, 'sl-formItem')}
      style={gap !== undefined ? { marginBottom: gap } : {}}
      label={
        label && (
          <>
            <span className={cs(styles.label, 'label')}>{label}</span>
            {getDesc(desc)}
          </>
        )
      }
      {...rest}
    />
  )
}

export default FormItem
